'use strict';

const $ = window.jQuery;

module.exports = function () {
    // Smooth Scroll
    $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
            if (
                location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
                location.hostname === this.hostname
            ) {
                let target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                if (target.length) {
                    if (!$(target).hasClass('targeted-el')) {
                        event.preventDefault();
                    }

                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000, function () {
                        window.location.hash = target.selector;
                    });
                }
            }
        });
};
